import React from 'react'
import { createPortal } from 'react-dom'
import cn from 'classnames'
import { Share2, Eye, Bitcoin } from 'lucide-react'
import Tray from 'components/shared/Tray'
import trayStyles from 'components/shared/share-tray.module.scss'
import styles from 'components/modals/share-rewards-info.module.scss'

// Explains the share-view reward scheme. Opened from the share-view line on
// the daily-earnings card (including its $0 state — that line exists to make
// the program discoverable) and from the rewarded share-link pill.
export default function ShareRewardsInfoTray({
    isOpen,
    onDismiss,
}: {
    isOpen: boolean
    onDismiss: () => void
}) {
    if (!isOpen) return null

    return createPortal(
        <Tray
            title="Share view rewards"
            onDismiss={onDismiss}
            trayClassName={cn(trayStyles.shareTray, trayStyles.shareTrayDialog)}
            bodyClassName={trayStyles.shareTrayBody}
            closeLabel="Close share rewards info"
            dialogTestId="share-rewards-info-tray"
            closeButtonTestId="share-rewards-info-tray-close"
        >
            <div className={styles.body}>
                <ol className={styles.steps}>
                    <li className={styles.step}>
                        <span className={styles.stepIcon}>
                            <Share2 size={16} aria-hidden="true" />
                        </span>
                        <span>
                            <strong>Share a post</strong> — anywhere.
                        </span>
                    </li>
                    <li className={styles.step}>
                        <span className={styles.stepIcon}>
                            <Eye size={16} aria-hidden="true" />
                        </span>
                        <span>
                            <strong>Someone new opens it</strong> — you earn 1¢.
                        </span>
                    </li>
                    <li className={styles.step}>
                        <span className={styles.stepIcon}>
                            <Bitcoin size={16} aria-hidden="true" />
                        </span>
                        <span>
                            <strong>Get paid daily</strong> — BSV, straight to your wallet.
                        </span>
                    </li>
                </ol>
                <p className={styles.footnote}>First-time visitors only. Daily caps apply.</p>
            </div>
        </Tray>,
        document.body,
    )
}
